<template>
  <window-container class="requirement-list-window">
    <div class="card">
      <div class="no-print" style="text-align:right;padding-top:10px;padding-right:10px;">
        <el-button type="primary" icon="el-icon-printer" @click="print">Print</el-button>
        <el-button type="success" icon="el-icon-message" @click="email">Email</el-button>
      </div>
      <div class="title">{{ company.name }} Requirement</div>
      <table class="requirement-table">
        <tr>
          <th>Part Number</th>
          <th>Description</th>
          <th>Brand</th>
          <th>Qty</th>
          <th>Price</th>
          <th>remark</th>
        </tr>
        <template v-for="item in formatedList">
          <!--
          <tr v-if="item.is_category" :key="item.id">
            <td colspan="6" class="td-category">{{ item.category_name }}</td>
          </tr>
          -->
          <tr v-if="item.is_class" :key="item.id">
            <td class="td-class" colspan="6">{{ item.class_name }}</td>
          </tr>
          <tr v-if="!item.is_category && !item.is_class" :key="item.id">
            <td>
              <a @click="openProduct(item.product_id)">{{ item.part_no }}</a>
            </td>
            <td>{{ item.description }}</td>
            <td>{{ item.brand }}</td>
            <td>{{ item.display_qty }}</td>
            <td>{{ item.display_price }}</td>
            <td>{{ item.remark }}</td>
          </tr>
        </template>
      </table>
    </div>
  </window-container>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      total: 0,
      company: {
        id: 0,
        name: ''
      },
      lookback: 30
    }
  },
  computed: {
    formatedList () {
      if (!this.list || this.list.length === 0) {
        return []
      }
      let category_name = ''
      let class_name = ''
      let list = this.list.concat()
      for (let i = 0; i < list.length; i++) {
        if (list[i].category_name != category_name) {
          list.splice(i, 0, {
            category_name: list[i].category_name,
            is_category: true
          })
          category_name = list[i].category_name
        }
        if (++i >= list.length) {
          break;
        }
        if (list[i].class_name != class_name) {
          list.splice(i, 0, {
            class_name: list[i].class_name,
            is_class: true
          })
          class_name = list[i].class_name
        }
        i++
      }
      return list
    }
  },
  mounted () {
    this.fetchCompany()
  },
  methods: {
    fetchCompany () {
      this.$http.get('/dbapi/last_require_company').then(data => {
        if (data.list.length > 0) {
          this.company = data.list[0]
          this.fetchList()
        }
      })
    },
    fetchList () {
      if (this.company.id === 0) {
        return
      }
      this.$http.get('/dbapi/requirement_list', {
        params: {
          company_id: this.company.id,
          lookback: this.lookback
        }
      }).then(data => {
        this.loading = false
        this.list = data.list
        this.total = data.total
      }).catch(() => this.loading = false)
    },
    openProduct (product_id) {
      let win = window.open('/product/' + product_id + '/require', 'requirement', 'height=700,width=1200,top=50,left=200,toolbar=yes,menubar=yes,scrollbars=no,resizable=yes,location=no,status=no')
      win.onbeforeunload = () => {
        this.fetchList()
      }
    },
    goRefer () {
      this.$router.push('/requirement-refer')
    },
    goReferDetail () {
      this.$router.push('/requirement-refer-detail')
    },
    print () {
      window.print()
    },
    email () {
      let win = this.$open('/loading', 1050)
      this.$http.post('/api/mail-create', {
        template: 'requirement-company',
        company: this.company.name,
        subject: this.company.name + ' requirement',
        columns: [
          { key: 'part_no', title: 'Part Number' },
          { key: 'description', title: 'Description' },
          { key: 'brand', title: 'Brand' },
          { key: 'display_qty', title: 'Qty' },
          { key: 'display_price', title: 'Price' },
          { key: 'remark', title: 'Remark' }
        ],
        list: this.formatedList
      }).then(result => {
          win.location = '/email/' + result.insertId
      })
    }
  }
}
</script>

<style>
.requirement-list-window {
  font-size: 12px;
}
.requirement-list-window .title {
  font-size: 16px;
  font-weight: bold;
  color: #f28500;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 4px;
}
.requirement-list-window .requirement-table {
  width: 100%;
  border-spacing: 0;
  font-size: 14px;
}
.requirement-list-window .requirement-table th {
  background: url('../../assets/table-th-bg.png') repeat-x;
  color: #000;
  text-align: left;
  padding-left: 4px;
  border-right: 1px solid #94bfff;
  border-bottom: 1px solid #648ccb;
}
.requirement-list-window .requirement-table td {
  padding-left: 4px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-bottom: 1px solid #DFDFDF;
}
.requirement-list-window .requirement-table .el-button--text {
  padding: 0;
}
.requirement-list-window .requirement-table .el-button--text .icon-cart {
  color: #ec4208;
}
.requirement-list-window .requirement-table .icon-in-cart {
  color: #008B00;
}
.requirement-list-window .requirement-table .td-category {
  background-color: #fff;
  color: #2a4e94;
  border-bottom: 1px solid #5c89d0;
  font-weight: bold;
  font-size: 14px;
}
.requirement-list-window .requirement-table .td-class {
  color: #ec4208;
  background: #CCC;
  font-weight: bold;
  font-size: 14px;
}
</style>